import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alert/index.js